"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutPageSelectionChange = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var layout_change_base_1 = require("../layout-change-base");
var LayoutPageSelectionChange = (function (_super) {
    tslib_1.__extends(LayoutPageSelectionChange, _super);
    function LayoutPageSelectionChange(index, changeType, areaChanges) {
        if (areaChanges === void 0) { areaChanges = []; }
        var _this = _super.call(this, index, changeType) || this;
        _this.areaChanges = areaChanges;
        return _this;
    }
    LayoutPageSelectionChange.prototype.reduceChanges = function () {
        throw new Error(errors_1.Errors.InternalException);
    };
    return LayoutPageSelectionChange;
}(layout_change_base_1.LayoutChangeBase));
exports.LayoutPageSelectionChange = LayoutPageSelectionChange;
